export default "__VITE_ASSET__d8d1fe95__"